import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import "./App.css";
import confetti from "canvas-confetti";
import Mascote from "./Mascote";
import { Routes, Route, Link } from "react-router-dom";
import MascotePage from "./MascotePage";

const frases = [
  "Você sempre diz que as coisas não me afetam, mas você não sabe o quanto eu me preocupo com você.",
  "Se eu tivesse que repetir e passar por tudo aquilo de novo, eu faria... só para ter você comigo.",
  "Eu nunca tive medo de morrer, mas eu tenho medo de perder você.",
  "Você pede desculpas por ficar com vergonha, mas eu não me importo. Eu só quero que você saiba que eu estou aqui para você.",
  "Eu te falava que queria ser um passarinho livre, mas eu não quero mais voar e nem vomitar na bocas dos meu filhoskkkkkk. Eu só quero ficar aqui com você.",
  "Quando ele disse que queria ficar com você, eu senti algo diferente. Depois eu entendi que era ciúmes. Eu não queria que você ficasse com ele, eu queria que você ficasse comigo.",
  "Eu te amo tanto.",
  "Essa é de Nier e me faz lembrar de você: Não se sinta mal por isso. Afinal, estamos vivos. E estar vivo é praticamente uma constante fonte eterna de constrangimento.",
  "Você sempre diz que sou louco por te achar linda, mas você não sabe o quanto eu me sinto sortudo por ter você ao meu lado.",
  "Essa é do livro de SAO: Eu também... carregarei com você. Cada fardo que você tiver, eu carregarei com você. Eu prometo. Definitivamente, vou te proteger de agora em diante...",
  "Essa foi em One Piece, pra Robin e eu lembrava dela quando você falava sobre se sentir sozinha: Ninguém nasce neste mundo para ficar sozinho… ",
  "Você disse que sou complicado pois eu não expresso nada, mas você não sabe o quanto eu me esforço para tentar me abrir com você. Você é a única que eu quero.",
  "Somos muito diferentes, mas eu gosto disso. Mostra que somos únicos e especiais. Você é especial para mim.",
  "Sempre me perguntavam se eu gostava de você e eu dizia que não, mas no fundo eu sabia que era mentira. Eu sempre gostei de você.",
  "Quando tive que sentar longe de você, eu me senti perdido. Eu não sabia o que fazer sem você ao meu lado. Você é a minha luz.",
  "Jamais pensei que eu ia gostar de trabalhar, mas quando você começou a falar comigo, eu percebi que era diferente. Eu não me importava mais com o trabalho, eu só queria ficar perto de você.",
  "Passo uma hora no onibus pra ir te ver e outra pra voltar pra casa, mas eu não me importo. Eu só quero te ver pelo menos um pouco.",
  "Te vejo todos os dias e mesmo assim sinto saudades de você. Eu não consigo parar de pensar em você.",
  "Eu não esperava passar por um relacionamento denovo depois de tudo o que aconteceu, mas quando você apareceu, eu percebi que era diferente. Você é diferente.",
  "Sempre te falei que eu tinha medo de me expor demais, mas com você é diferente. Eu não tenho medo de me abrir com você. Com você, eu me sinto seguro.",
  "Onde quer que você vá, eu vou com você. Eu não me importo com o que aconteça. Só quero ficar com você.",
  "As vezes tenho medo de achar que não sou bom o suficiente para você, Você é tão perfeita e eu sou tão... eu. Mas você sempre me diz que gosta do jeito que sou e isso me faz sentir especial.",
  "Desde sempre eu te dizia que tinha medo de pessoas, mas com você... eu não tenho medo. Não tenho medo de nada com você. Somente de perder você.",
  "Você dizia que eu não te conhecia pra te amar, pouco me importa oque você fez ou deixou de fazer. Eu só quero saber o que você é agora. E agora, você é a pessoa mais importante da minha vida.",
  "Minha princesinha. Você sempre fica timida quando eu falo isso, mas você é a minha princesa. Não sou o principe que você merece, mas eu sou o seu principe. E eu sempre vou te proteger.",
  "Nunca vou enjoar de você. A cada dia que passa, eu me apaixono mais por você.",
  "Muitas frases aqui eu já te falei, mas eu não me importo. Eu só quero que você saiba o quanto eu te amo.",
  "Por sermos diferentes, as vezes temos dificuldades de nos entender. Mas eu quero que você saiba que eu sempre vou tentar entender você. Você é a minha prioridade.",
  "Gostamos de coisas diferentes, mas isso não importa. O que importa é que nós nos amamos e isso é tudo o que eu preciso.",
  "Você diz que só escuto músicas tristes, mas eu escuto músicas felizes também. E quando eu escuto músicas felizes, eu sempre penso em você.",
  "Não sei se tudo que eu faço é certo, mas eu sempre faço o que eu acho que é melhor pra você. Eu só quero o seu bem.",
  "Você é tao inteligente e esperta, mas as vezes você se subestima. Você é mais do que você pensa. Você é incrível.",
  "Sempre que você começa a me explicar algo de suas coisinhas, eu entro em um transe profundo. Eu não consigo parar de olhar pra você. Você é tão linda e perfeita.",
  "Você diz que não faz sentido eu gostar de você, que você não tem nada de especial. Mas quando eu olho pra você, eu vejo tudo o que eu sempre procurei. Você é especial pra mim.",
  "Quando a gente se beijou pela primeira vez, eu não sabia o que fazer. Eu estava tão nervoso e feliz ao mesmo tempo. Eu não consigo explicar o que eu senti. Foi mágico.",
  "Não existe nada que eu não faria por você. Eu faria qualquer coisa para te ver feliz.",
];

const imagens = Array.from({ length: 31 }, (_, i) => `/fotos/foto${i + 1}.jpg`);

const musicas = [
  {
    src: "/audios/audio2.opus",
    letra: `I said I would never fall unless it's you I fall into\nI was lost within the darkness, but then I found her\nI found you`,
  },
  {
    src: "/audios/audio1.opus",
    letra: `But that's all right with me\nIt's really no fuss\nAs long as you're next to me\nJust the two of us`,
  },
];

const eventos = [
  {
    data: "27/12/2024",
    titulo: "Nos conhecemos",
    descricao: "Foi nesse dia que tudo começou...",
  },
  {
    data: "11/03/2025",
    titulo: "Primeiro beijo",
    descricao: "Beijinhos nosso💋",
  },
  {
    data: "11/05/2025",
    titulo: "Aniversário de namoro",
    descricao: "Nosso primeiro mês juntos!",
  },
];

const coisasQueAmo = [
  "Seu sorriso que você tenta esconder",
  "O jeito que você morre de vergonha quando eu falo algo",
  "Você me chamando de 'meu amor'",
  "A sua risada quando você se diverte",
  "Quando você se empolga falando de algo que gosta",
  "Quando você vem me ver",
  "O seu toque",
  "Você dizendo que me quer",
];

const coisasQueAmoDefinitiva = [
  "A verdade é que eu amo tudo em você, cada minuto, cada segundo, cada mínimo detalhe. Sou completamente apaixonado por você.",
];

function LinhaDoTempo() {
  return (
    <motion.div
      className="mt-10 w-full max-w-xl mx-auto"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
    >
      <motion.h2
        className="text-2xl font-bold text-pink-700 mb-4"
        initial={{ opacity: 0, scale: 0.8 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Nossa Linha do Tempo
      </motion.h2>
      <ul className="space-y-4">
        {eventos.map((evento, idx) => (
          <motion.li
            key={idx}
            className="bg-pink-100 rounded-xl p-4 shadow flex flex-col md:flex-row md:items-center gap-2"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: idx * 0.1 }}
            viewport={{ once: true }}
          >
            <span className="font-bold text-pink-600">{evento.data}</span>
            <span className="font-semibold">{evento.titulo}</span>
            <span className="text-pink-800">{evento.descricao}</span>
          </motion.li>
        ))}
      </ul>
    </motion.div>
  );
}

// Função para pegar uma frase diferente a cada dia
function mensagemDoDia() {
  const hoje = new Date();
  const seed =
    hoje.getFullYear() * 10000 +
    (hoje.getMonth() + 1) * 100 +
    hoje.getDate();
  if (!Array.isArray(frases) || frases.length === 0) return "";
  const idx = seed % frases.length;
  // Verificação extra para garantir que sempre retorna uma string
  return typeof frases[idx] === "string" ? frases[idx] : "";
}

// NOVA FUNÇÃO: retorna o índice da mensagem do dia
function indiceMensagemDoDia() {
  const hoje = new Date();
  const seed =
    hoje.getFullYear() * 10000 +
    (hoje.getMonth() + 1) * 100 +
    hoje.getDate();
  if (!Array.isArray(frases) || frases.length === 0) return -1;
  return seed % frases.length;
}

function App() {
  // Pega o índice da mensagem do dia para evitar repetir
  const idxMsgDia = indiceMensagemDoDia();

  // Inicializa com um índice aleatório diferente da mensagem do dia
  const [indiceFrase, setIndiceFrase] = useState(() => {
    let idx = Math.floor(Math.random() * frases.length);
    // Garante que não seja a mensagem do dia
    while (idx === idxMsgDia) {
      idx = Math.floor(Math.random() * frases.length);
    }
    return idx;
  });

  // Inicializa com uma imagem aleatória
  const [indiceImagem, setIndiceImagem] = useState(() =>
    Math.floor(Math.random() * imagens.length)
  );
  const [indiceMusica, setIndiceMusica] = useState(0);
  const [chatMsg, setChatMsg] = useState("");
  const [chat, setChat] = useState(() => {
    const salvo = localStorage.getItem("chat");
    return salvo ? JSON.parse(salvo) : [];
  });
  const [autor, setAutor] = useState("Você");
  const [imagemLightbox, setImagemLightbox] = useState(null);
  const [tempoJuntos, setTempoJuntos] = useState({ d: 0, h: 0, m: 0, s: 0 });
  const [fade, setFade] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error("Erro ao reproduzir o áudio:", error);
      });
    }
  }, [indiceMusica]);

  useEffect(() => {
    const timer = setInterval(() => {
      const inicio = new Date("2025-04-11T22:30:00");
      const agora = new Date();
      const diff = agora - inicio;
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      setTempoJuntos({ d, h, m, s });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const novoIndiceDiferente = (tamanho, atual) => {
    let novo = atual;
    while (novo === atual) {
      novo = Math.floor(Math.random() * tamanho);
    }
    return novo;
  };

  const trocarMensagemEImagem = () => {
    confetti({ particleCount: 60, spread: 70, origin: { y: 0.7 } });
    setFade(true);
    setTimeout(() => {
      // Filtra frases para não incluir a mensagem do dia
      const idxMsgDia = indiceMensagemDoDia();
      const frasesSemMsgDia = frases.filter((_, idx) => idx !== idxMsgDia);
      const imagensSemMsgDia = imagens; // imagens não precisam ser filtradas

      // Sorteia novo índice para frase (sem a mensagem do dia)
      let novoFrase = indiceFrase;
      while (frases[novoFrase] === frases[idxMsgDia] || novoFrase === indiceFrase) {
        novoFrase = Math.floor(Math.random() * frasesSemMsgDia.length);
      }
      // Ajusta para o índice real na lista original
      const realFraseIdx = frases.findIndex(f => f === frasesSemMsgDia[novoFrase]);

      setIndiceFrase(realFraseIdx);
      setIndiceImagem(novoIndiceDiferente(imagensSemMsgDia.length, indiceImagem));
      setFade(false);
    }, 300);
  };

  const trocarMusica = () => {
    const novoMusica = novoIndiceDiferente(musicas.length, indiceMusica);
    setIndiceMusica(novoMusica);
    if (audioRef.current) {
      audioRef.current.load();
      audioRef.current.play().catch(() => {});
    }
  };

  const interagirMascote = () => {
    alert("Oi! Eu sou o mascote do site! 💖");
    // Aqui você pode adicionar animações, frases aleatórias, etc.
  };

  return (
    <>
      <nav className="fixed top-0 left-0 w-full bg-pink-100 shadow z-50 flex justify-center gap-6 py-2">
        <Link to="/" className="text-pink-700 font-bold hover:underline">Início</Link>
        <Link to="/mascote" className="text-pink-700 font-bold hover:underline">Mascote</Link>
      </nav>
      <div className="pt-16">
        <Routes>
          <Route path="/" element={
            <div className="min-h-screen flex flex-col items-center justify-center bg-pink-50 text-center p-4 relative overflow-hidden">
              {/* Corações animados no fundo */}
              <div className="heart-bg">
                <div className="heart" style={{ left: "10%", animationDelay: "0s" }} />
                <div className="heart" style={{ left: "30%", animationDelay: "2s" }} />
                <div className="heart" style={{ left: "50%", animationDelay: "4s" }} />
                <div className="heart" style={{ left: "70%", animationDelay: "1s" }} />
                <div className="heart" style={{ left: "85%", animationDelay: "3s" }} />
              </div>

              <motion.h1
                className="text-4xl font-extrabold text-pink-700 mb-2 drop-shadow-lg"
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                Para você Nanay, meu amor 💖
              </motion.h1>

              <motion.img
                src={imagens[indiceImagem]}
                alt="Foto nossa"
                className="w-64 h-64 object-cover rounded-2xl shadow-xl border-4 border-pink-200 ring-4 ring-pink-100"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: fade ? 0 : 1, scale: 1 }}
                transition={{ duration: 0.7 }}
                whileHover={{ scale: 1.05, rotate: 2 }}
              />

              <motion.p
                className="text-xl mt-4 text-pink-800 italic font-semibold animate-pulse"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: fade ? 0 : 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                {frases[indiceFrase]}
              </motion.p>

              <motion.div
                className="mt-6 p-4 bg-white bg-opacity-80 rounded-xl shadow-md border border-pink-100 flex flex-col items-center"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <span className="text-pink-600 text-lg font-bold mb-2 animate-bounce">
                  🎶 Essa me lembra você 🎶
                </span>
                <blockquote className="text-pink-700 italic mb-2 leading-relaxed whitespace-pre-line">
                  {musicas[indiceMusica].letra}
                </blockquote>
                <div className="flex gap-4 mb-2">
                  <button
                    onClick={trocarMusica}
                    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-400 to-pink-600 text-white rounded-full hover:scale-105 hover:from-pink-500 hover:to-pink-700 shadow-lg transition-all duration-200 text-lg font-bold"
                    aria-label="Próxima música"
                  >
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path d="M5 4v16l12-8L5 4z" fill="currentColor" />
                    </svg>
                    Próxima
                  </button>
                  <button
                    onClick={() => {
                      audioRef.current.currentTime = 0;
                      audioRef.current.play();
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-pink-200 text-pink-700 rounded-full hover:bg-pink-300 shadow transition text-lg font-bold"
                    aria-label="Repetir música"
                  >
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M17 1l4 4-4 4M21 5H7a4 4 0 0 0 0 8m0 6l-4-4 4-4m-4 4h14a4 4 0 0 0 0-8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Repetir
                  </button>
                </div>
                <audio ref={audioRef} controls className="w-64 rounded-lg shadow-sm">
                  <source src={musicas[indiceMusica].src} type="audio/ogg" />
                  Seu navegador não suporta o elemento de áudio.
                </audio>
              </motion.div>

              <motion.button
                whileTap={{ scale: 0.95, rotate: -2 }}
                whileHover={{ scale: 1.07, backgroundColor: "#f472b6" }}
                onClick={trocarMensagemEImagem}
                className="mt-4 px-4 py-2 bg-pink-600 text-white rounded-xl shadow hover:bg-pink-700 transition"
              >
                Mostrar outra lembrança 💭
              </motion.button>

              {/* Contador */}
              <motion.div
                className="mt-10 text-pink-700 font-bold text-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                Estamos juntos há{" "}
                <span className="text-pink-600">
                  {tempoJuntos.d} dias, {tempoJuntos.h}h {tempoJuntos.m}m {tempoJuntos.s}s
                </span>{" "}
                ! 💑
              </motion.div>

              {/* Mensagem do Dia */}
              <motion.div
                className="mt-10 w-full max-w-xl mx-auto"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <h2 className="text-2xl font-bold text-pink-700 mb-2">
                  Mensagem do Dia 💌
                </h2>
                <div className="bg-pink-100 rounded-xl p-4 shadow text-pink-800 text-lg font-semibold italic">
                  {mensagemDoDia()}
                </div>
              </motion.div>

              <LinhaDoTempo />

              {/* Galeria */}
              <motion.div
                className="mt-10 w-full max-w-2xl mx-auto"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <h2 className="text-2xl font-bold text-pink-700 mb-4">Nossa Galeria</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {imagens.map((src, idx) => (
                    <motion.img
                      key={idx}
                      src={src}
                      alt=""
                      className="rounded-xl shadow-md object-cover w-full h-32 cursor-pointer"
                      onClick={() => setImagemLightbox(src)}
                      whileHover={{ scale: 1.1, boxShadow: "0 0 20px #f472b6" }}
                      transition={{ type: "spring", stiffness: 300 }}
                    />
                  ))}
                </div>
                {imagemLightbox && (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                    onClick={() => setImagemLightbox(null)}
                  >
                    <motion.img
                      initial={{ scale: 0.7, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.7, opacity: 0 }}
                      src={imagemLightbox}
                      alt=""
                      className="max-h-[80vh] max-w-[90vw] rounded-2xl shadow-2xl border-4 border-pink-200"
                    />
                  </div>
                )}
              </motion.div>

              <motion.div
                className="mt-10 w-full max-w-xl mx-auto"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <h2 className="text-2xl font-bold text-pink-700 mb-4">
                  Coisinhas que amo em você
                </h2>
                <ul className="grid grid-cols-2 gap-3">
                  {coisasQueAmo.map((item, idx) => (
                    <motion.li
                      key={idx}
                      className="bg-pink-100 rounded-xl p-3 shadow text-pink-700 font-semibold"
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.4, delay: idx * 0.1 }}
                      viewport={{ once: true }}
                      whileHover={{ scale: 1.08, boxShadow: "0 0 16px #f472b6" }}
                    >
                      ❤️ {item}
                    </motion.li>
                    
                  ))}
                </ul>
                <motion.div
                  className="bg-pink-200 rounded-xl p-4 shadow text-pink-800 font-semibold mt-4"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.05, boxShadow: "0 0 16px #f472b6" }}
                >
                  ❤️ {coisasQueAmoDefinitiva[0]}
                </motion.div>
              </motion.div>
            </div>
          } />
          <Route path="/mascote" element={<MascotePage />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
